import { c as _c } from "react/compiler-runtime";
import type { Table } from '@tanstack/react-table';
import { Fragment } from 'react';
import { Button } from '@/components/ui/button';
import { HEAD_HEIGHT } from '@/components/ui/table-element';
export function TableGoToLastPage(t0) {
  const $ = _c(7);
  const {
    table
  } = t0;
  const dataRows = table.getRowModel().rows;
  const canNavigateToLastPage = dataRows.length === 0 && table.getPageCount() > 0;
  let t1;
  if ($[0] !== table) {
    t1 = function handleGoToLastPage() {
      table.setPageIndex(table.getPageCount() - 1);
    };
    $[0] = table;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleGoToLastPage = t1;
  let t2;
  if ($[2] !== canNavigateToLastPage || $[3] !== handleGoToLastPage) {
    t2 = canNavigateToLastPage ? <div style={{
      "--h": `${HEAD_HEIGHT}px`
    }} className="h-[calc(100%-var(--h))]"><Button variant="ghost" className="size-full rounded-none sq:rounded-none" onClick={handleGoToLastPage}><svg className="icon-[material-symbols-light--arrow-back-2-outline] size-9" /></Button></div> : null;
    $[2] = canNavigateToLastPage;
    $[3] = handleGoToLastPage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <Fragment>{t2}</Fragment>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}